import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';
import { BasicBarChartProps } from './types';
import ChartWrapper from '../../ChartWrapper';
const DEFAULT_STYLE = {
  height: 282,
};

function BasicBar({
  data,
  isOrgAnalytics = false,
  chartTitle,
  onLegendSelect = () => {},
}: BasicBarChartProps) {
  const option: EChartsOption = useMemo(() => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
        },
      },
      xAxis: {
        type: 'category',
        data: data.map(item => item.name),
        axisLabel: {
          hideOverlap: true,
          // interval: 0,
          // overflow: 'truncate',
          // width: 60,
          // ellipsis: '...',
          // verticalAlign: 'top',
          // rotate: -45,
        },
        axisTick: {
          alignWithLabel: true,
        },
        // boundaryGap: true,
      },
      yAxis: {
        type: 'value',
      },
      grid: {
        left: 50,
        right: 30,
        top: 10,
        bottom: 30,
      },
      series: [
        {
          data: data.map(item => item.value),
          type: 'bar',
        },
      ],
    };
  }, [data]);

  const events = useMemo(() => {
    return {
      legendselectchanged: (param: any, echarts: any) => {
        onLegendSelect(param.name);
      },
    };
  }, []);

  return (
    <ChartWrapper>
      <ReactECharts option={option} style={DEFAULT_STYLE} onEvents={events} />
    </ChartWrapper>
  );
}

export default React.memo(BasicBar);
